;(function() {

	var allTitle = [],
		 titles = document.querySelectorAll('#masonry-grid p'),
		 $grid = jQuery('#masonry-grid'),
		 windowWidth = jQuery(window).width(),
		 searchBox = jQuery('#search'),
		 sharelink = '';

		// layout on imagesLoaded
		$grid.masonry({
			columnWidth: '.grid-item',
			itemSelector: '.grid-item',
			horizontalOrder: true,
			percentPosition: true,
			isResizable: true,
			transitionDuration: '0.5s',
			resize: false,
			animate: true,
			loadingImg: "/js/ajax-loader.gif",
		});

		// layout Masonry after each image loads
		$grid.imagesLoaded().progress(function (instance, image) {
			var result = image.isLoaded ? 'loaded' : 'broken';
			$grid.masonry('reloadItems').masonry();
			console.log('image is ' + result + ' for ' + image.img.src);
		});


		jQuery(window).on('load', function ($) {
		var msnry = $grid.data('masonry');
		$grid.infiniteScroll({
			path: 'page/{{#}}/' + window.location.search,
			append: '.grid-item',
			history: false,
			outlayer: msnry,
			status: '.page-load-status',
			scrollThreshold: 100,
			loadOnScroll: true
		});
	    });



    titles.forEach(function(title) {
        var results = title.dataset.title;
        allTitle.push(results);
	});

    if (searchBox.val() === '') { jQuery('.spinner').hide();  }

    if (!jQuery('body').hasClass('page-template-template-gallery-new')) {
        jQuery("#search").autocomplete({

            search: function(event, ui) {
                jQuery('.spinner').show();
            },
            open: function(event, ui) {
                jQuery('.spinner').hide();
            },
            response: function(event, ui) {
                if (!ui.content.length) {
                    var noResult = { value: "", label: "No results found" };
                    if (noResult) {
                        ui.content.push(noResult);
                        jQuery('.spinner').hide();
                    }
                }
            },
            source: function(request, response) {
                var data = {
                    'action': 'update_draw_row_action',
                    'search_all_nonce': ajax_object.search_all_nonce
                };
                jQuery.getJSON(ajax_object.ajax_url + '?action=' + data.action + '&search_all_nonce=' + data.search_all_nonce + '&term=' + request.term, function(data) {
                    if (!data.length) {
                        console.info('no results found.');
                    }
                    response(jQuery.map(data, function(value, key) {
                        return {
                            value: value
                        };
                    }));
                });
            },
            select: function(event, ui) {
                if (jQuery(this).val(ui.item.value)) { jQuery(this).parents("form").submit();  }
            },
            minLength: 2,
            delay: 100,
            autoFocus: true,
            appendTo: "#search-results"
        });
    }


    jQuery('.mini-gallery-item').fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        nextEffect: 'none',
        prevEffect: 'none',
        padding: 0,
        margin: [20, 60, 20, 60]
    });


    jQuery('.main-content').on('click', '.gallery-open-button', function(e) {
        e.preventDefault();
		var id = jQuery(this).attr('id'),
			imagearray = [],
			titlefancy = jQuery(this).attr('data-title');

        jQuery('#' + id + ' img').each(function() {
            imagearray.push(jQuery(this).attr('src'));
        });

        jQuery.fancybox(imagearray, {
            openEffect: 'none',
            closeEffect: 'none',
            nextEffect: 'fade',
            prevEffect: 'fade',
            titlePosition: 'inside',
            titleShow: true,
            title: titlefancy,
            overlayShow: true,
            padding: 0,
            type: 'image',
            margin: [20, 20, 20, 20]
        });
    });


    jQuery('.main-content').on('click', '.gallery_light_box', function(e) {
        e.preventDefault();
		var href = jQuery(this).attr('data-share-link');
        if (href) { sharelink = href; }
        jQuery('#share-gallery').modal('show');
	});

    jQuery('#share-gallery').on('shown.bs.modal	', function(e) {
        if (sharelink !== '') {
            jQuery('#to-clipboard').val(sharelink);
            sharelink = '';
        }
	});

})();